import {StateProvider} from "@uirouter/angularjs";
import {AccountPerformanceView} from "./view/AccountPerformanceViewComponent";
import {AccountPerformanceViewStoreFactory} from "./service/AccountPerformanceViewStoreFactory";
import {AccountPerformanceViewStore} from "./service/AccountPerformanceViewStore";
import {PerformanceStateParams} from "./models/PerformanceStateParams";
import {AnalyticsType} from "../analytics/models/AnalyticsType";
import {AnalyticsService} from "../analytics/services/AnalyticsService";

/** @ngInject */
export function routerConfig($stateProvider: StateProvider) {
    $stateProvider.state("performance", {
        url: "/performance/{portfolioId:int}",
        component: AccountPerformanceView,
        resolve: {
            viewStore: viewStoreResolver
        },
        data: {
            pageTitle: "Account Performance"
        },
        /** @ngInject */
        onEnter: (analyticsService) => analyticsService.submit(AnalyticsType.VISIT_PERFORMANCE),
        onExit: cleanUp
    });

    $stateProvider.state("history", {
        url: "/history/{portfolioId:int}",
        redirectTo: "performance"
    });
}

/** @ngInject */
export function viewStoreResolver(accountPerformanceViewStoreFactory: AccountPerformanceViewStoreFactory,
                                  $stateParams: PerformanceStateParams) {
    return accountPerformanceViewStoreFactory.create($stateParams.portfolioId);
}

/** @ngInject */
export function cleanUp(viewStore: AccountPerformanceViewStore) {
    viewStore.destroy();
}
